import React from 'react';

import type { IRichContentActivity } from '@wix/social-groups-serverless/dist/feed/types';

import { useRichContent } from 'common/utils/ricos';
import { RicosViewer } from 'common/components/Ricos/RicosViewer';
import { jsonrepair } from 'jsonrepair';

import { GROUPS_APP_DEFINITION_ID } from '../../../../../constants';

import { IActivityContentProps } from './types';

export function RichContentActivity(props: IActivityContentProps) {
  const { item } = props;

  const feedItemId = item.feedItemId as string;
  const data = item?.activity?.data as IRichContentActivity;
  const groupId = item.applicationContext?.contextId as string;

  const content = useRichContent(
    sanitizeTextContent(data.content, data.activity === 'event_added'),
  );

  return (
    <RicosViewer
      usage="FeedItem"
      content={content}
      postId={feedItemId}
      containerId={GROUPS_APP_DEFINITION_ID}
      groupId={groupId}
      contentId={item.feedItemId}
    />
  );

  function sanitizeTextContent(input: string, shouldReplace: boolean): string {
    if (!shouldReplace) {
      return input;
    }
    try {
      return jsonrepair(input.replace(/\n/g, ' '));
    } catch {
      return input;
    }
  }
}

RichContentActivity.displayName = 'RichContentActivity';
